import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import DocumentsList from "../components/DocumentsList";
import { EQUIPMENT_DOC_CATEGORIES } from "../lib/utils-app";
import { ArrowLeft, Wrench } from "lucide-react";

export default function EquipmentDetail() {
  const { id } = useParams();
  const [e, setE] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get(`/equipment/${id}`);
      setE(data);
      const c = await api.get(`/companies/${data.company_id}`);
      setCompany(c.data);
    })();
  }, [id]);

  if (!e) return <div className="text-slate-500">Caricamento…</div>;

  return (
    <div className="space-y-6">
      <Link to={`/aziende/${e.company_id}`} className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900">
        <ArrowLeft size={14} /> {company?.ragione_sociale || "Azienda"}
      </Link>

      <header className="bg-white border border-slate-200 rounded-lg p-6 flex items-start gap-4">
        <div className="w-14 h-14 rounded-lg bg-blue-50 text-blue-800 flex items-center justify-center"><Wrench size={26} /></div>
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-blue-700 mb-1">Attrezzatura</div>
          <h1 className="font-display text-2xl font-bold text-slate-900">{e.tipologia}</h1>
          <div className="text-sm text-slate-500 mt-1">{e.marca} {e.modello}</div>
        </div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Info label="Matricola" v={e.matricola} mono />
        <Info label="Anno" v={e.anno} />
        <Info label="N° immatricolazione" v={e.numero_immatricolazione} mono />
      </div>

      <section>
        <h2 className="font-display font-semibold text-slate-900 mb-3">Documenti attrezzatura</h2>
        <DocumentsList entityType="equipment" entityId={e.id} companyId={e.company_id} categories={EQUIPMENT_DOC_CATEGORIES} />
      </section>
    </div>
  );
}

function Info({ label, v, mono }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4">
      <div className="text-xs uppercase tracking-wider text-slate-500 font-mono">{label}</div>
      <div className={`mt-1 text-slate-900 ${mono ? "font-mono" : ""}`}>{v || "—"}</div>
    </div>
  );
}
